import { paths } from 'src/routes/paths';

import { getPlatformDisplayName } from 'src/utils/platform-label';

// ----------------------------------------------------------------------

/**
 * Where a notification's button takes the seller, and what it says. The server names the destination
 * (server/src/services/notification-actions.js): a Voolist page by what it shows, a marketplace post by its
 * address. This turns that into the page's address here, or null for a notification without a button.
 *
 * @param {(object|null|undefined)} action - The notification's `action`
 * @returns {({ label: string, href: string, external: boolean }|null)}
 */
export function notificationActionTarget (action) {
  switch (action?.to) {
    case 'listing':
      return action.listingId ? inApp('Open in Voolist', paths.dashboard.listing.edit(action.listingId)) : null;
    case 'marketplaces':
      return inApp('Go to Marketplaces', paths.management.stores);
    case 'bulkCrossListResults':
      return action.batchId ? inApp('See results', paths.dashboard.listing.bulkCrossListBatch(action.batchId)) : null;
    case 'mergeResults':
      return action.batchId ? inApp('See results', paths.dashboard.listing.mergeBatch(action.batchId)) : null;
    case 'post':
      // Only a web address opens: the button never runs anything else the notification might hold.
      return isWebAddress(action.url) && action.platform
        ? { label: `Open on ${getPlatformDisplayName(action.platform)}`, href: action.url, external: true }
        : null;
    default:
      return null;
  }
}

const inApp = (label, href) => ({ label, href, external: false });

const isWebAddress = (url) => typeof url === 'string' && url.startsWith('https://');
